module.exports = __webpack_public_path__ + "img/Close.e24585e5.svg";